export const QUERY_KEYS = {
  SESSIONS: 'sessions',
  LOCATIONS: 'locations',
  SESSION_DETAIL: 'session-detail',
  ENUMS: 'enums',
  CATCHES: 'catches',
  PHOTOS: 'photos',
  CATCH_FIELD_VALUES: 'catch-field-values',
  CATCH_SUMMARY: 'catch-summary',
  PHOTO_ALBUMS: 'photo-albums',
  PHOTO_ALBUM_DETAIL: 'photo-album-detail',
  SESSION_FIELD_VALUES: 'session-field-values',
  SHARED_ITEMS: 'shared-items',
  FORGOT_PASSWORD: 'forgot-password',
  RESET_PASSWORD: 'reset-password',
  NOTES: 'notes',
} as const

export const PAGINATION = {
  DEFAULT_LIMIT: 30,
  DEFAULT_SKIP: 0,
}

export const BASE_URL = process.env.NEXT_PUBLIC_API_URL

// export const BASE_URL = typeof window === 'undefined' ? 'http://backend:4433/api/v1' : process.env.NEXT_PUBLIC_API_URL
